// extracted by mini-css-extract-plugin
export default {"primary":"button_primary__ZBQkr","secondary":"button_secondary__AsKmU","cancel":"button_cancel__LzONe","outline":"button_outline__CvjMk","nav_link":"button_nav_link__HG8n6"};